import React from 'react';
import SurfaceCard from '../../common/SurfaceCard';
import ShimmerBox from './ShimmerBox';

export interface LogsCardShimmerProps {
  withLeadingContent?: boolean;
  className?: string;
}

const LogsCardShimmer: React.FC<LogsCardShimmerProps> = ({
  withLeadingContent = false,
  className = '',
}) => {
  const gridCols = withLeadingContent
    ? 'md:[grid-template-columns:auto_minmax(140px,200px)_230px_auto]'
    : 'md:[grid-template-columns:auto_230px_auto]';

  return (
    <div data-testid="logs-card-shimmer">
      <SurfaceCard
        className={['mb-4 md:min-h-[92px]', className].filter(Boolean).join(' ')}
        contentClassName="p-4 md:p-[18px_22px] md:pl-[26px]"
      >
        <div
          className={['relative z-[1] grid grid-cols-1 items-end gap-4 md:gap-10', gridCols].join(
            ' '
          )}
        >
          <div className="self-center md:min-w-[108px]">
            <ShimmerBox className="h-4 w-24 rounded-md" />
          </div>

          {withLeadingContent && (
            <div className="min-w-0 w-full space-y-2">
              <ShimmerBox className="h-3 w-24 rounded" />
              <ShimmerBox className="h-[34px] w-full max-w-[200px] rounded-lg" />
            </div>
          )}

          <div className="w-full max-w-[230px] min-w-0 space-y-2">
            <ShimmerBox className="h-3 w-28 rounded" />
            <ShimmerBox className="h-[34px] w-full rounded-lg" />
          </div>

          <div className="flex w-full gap-3 self-center md:w-auto md:justify-self-end">
            <ShimmerBox className="h-9 w-[88px] rounded-[10px]" />
            <ShimmerBox className="h-9 w-[108px] rounded-[10px]" />
          </div>
        </div>
      </SurfaceCard>
    </div>
  );
};

export default LogsCardShimmer;
